import { ReactNode } from "react";
import AbstractDoc from "../AbstractDoc";

export default class Condizioni_en extends AbstractDoc {

    protected getDoc(): ReactNode {
        return (
            <div>
                <h1>TERMS OF USE</h1>

                Welcome to the Android game (hereinafter "the Game"). Access to and use of the Game is subject to the following Terms of Use ("ToU"). Use of the Game implies full acceptance of the TOU by the user.

                <h2>USE LICENSE</h2>
                The Game is protected by intellectual property rights and by the applicable legal system. The Game developer grants you a personal, non-transferable, non-exclusive license to use the Game in accordance with these TOU. You have no right to use the Game not expressly contemplated in these TOU.

                <h2>CHANGES TO THE TOU</h2>
                The Game author reserves the right to modify, update or supplement the TOU at any time and at his own discretion, without prior notice to the user. You are responsible for periodically reviewing the TOU for any changes. Any use of the Game after the changes made to the ToU implies full acceptance of the same by the user.

                <h2>MAJOR AGE</h2>
                The user declares to be of legal age

                <h2>CONDITIONS FOR ACCESSING AND USING THE GAME</h2>
                You agree to use the Game in accordance with these TOU and applicable laws and regulations. Any use of the Game for illicit purposes or purposes contrary to public order, morality and morality is prohibited. In particular, the user undertakes not to use the Game to:

                disseminate offensive or defamatory messages;
                violate the intellectual property rights of the Game developer or any third party;
                use the Game for commercial or advertising purposes.
                The user is responsible for any use of the Game connected to his account and undertakes not to share his access credentials with third parties.

                <h2>WARRANTIES AND LIABILITY</h2>
                The Game author does not warrant that the Game is free from errors, viruses or other elements harmful to your device or your data. The author of the Game assumes no responsibility for any damages suffered by the user as a result of using the Game.

                <h2>INTELLECTUAL PROPERTY</h2>
                The Game is protected by the intellectual property rights of the Game developer. The user undertakes not to copy, modify, distribute, disseminate, publish or use in any way the Game or its contents without the prior written consent of the Game's author.

                <h2>SUSPENSION AND WITHDRAWAL</h2>
                The Game author reserves the right to suspend or revoke the user's license at any time
            </div>
        );
    }

}